import { render } from "./OrangeButton.vue?vue&type=template&id=fdfdab94&scoped=true"
import script from "./OrangeButton.vue?vue&type=script&lang=js"
export * from "./OrangeButton.vue?vue&type=script&lang=js"

import "./OrangeButton.vue?vue&type=style&index=0&id=fdfdab94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdfdab94"]])

export default __exports__